import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo2.png'


const _withScopeId = n => (_pushScopeId("data-v-5f8efadf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-pc" }
const _hoisted_2 = {
  key: 0,
  class: "top-seat"
}
const _hoisted_3 = {
  src: _imports_0,
  alt: "logo"
}
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(['sidebar-sub-icon', 'colour'])
}
const _hoisted_5 = {
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_6 = ["xlink:href"]
const _hoisted_7 = {
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_8 = ["xlink:href"]
const _hoisted_9 = { class: "sidebar-phone" }
const _hoisted_10 = {
  key: 0,
  class: "top-seat"
}
const _hoisted_11 = {
  class: /*#__PURE__*/_normalizeClass(['logo', 'posted'])
}
const _hoisted_12 = {
  class: /*#__PURE__*/_normalizeClass(['sidebar-sub-icon', 'colour'])
}
const _hoisted_13 = {
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_14 = ["xlink:href"]
const _hoisted_15 = {
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_16 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_menu, {
        router: "",
        "default-active": $setup.menuActive,
        class: _normalizeClass(['sidebar', 'sidebar-pc', { close: $setup.config.sidebarCollapse }]),
        collapse: $setup.config.sidebarCollapse,
        "collapse-transition": true
      }, {
        default: _withCtx(() => [
          _createCommentVNode(" 顶部占位符 "),
          ($setup.config.android)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_el_menu_item, {
            index: "/",
            class: "no-padding"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['logo', 'posted', { 'collapse': !$setup.config.sidebarCollapse }])
              }, [
                _withDirectives(_createElementVNode("img", _hoisted_3, null, 512 /* NEED_PATCH */), [
                  [_vShow, $setup.config.sidebarCollapse]
                ]),
                _withDirectives(_createVNode($setup["Logo"], null, null, 512 /* NEED_PATCH */), [
                  [_vShow, !$setup.config.sidebarCollapse]
                ])
              ], 2 /* CLASS */)
            ]),
            _: 1 /* STABLE */
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.routes, (routeItem) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: routeItem.path
            }, [
              (routeItem.meta.sidebar && $setup.userLimit(routeItem))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (routeItem.meta.submenu)
                      ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                          key: 0,
                          index: routeItem.path
                        }, {
                          title: _withCtx(() => [
                            _createCommentVNode(" <i :class=\"['sidebar-sub-icon', 'colour', 'colour-' + routeItem.meta.icon]\"></i> "),
                            _createElementVNode("i", _hoisted_4, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                                _createElementVNode("use", {
                                  "xlink:href": '#colour-' + routeItem.meta.icon
                                }, null, 8 /* PROPS */, _hoisted_6)
                              ]))
                            ]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`sidebar.${routeItem.meta.title}`)), 1 /* TEXT */)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routeItem.children, (childrenItem) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: childrenItem.path
                              }, [
                                (childrenItem.meta.sidebar)
                                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                      key: 0,
                                      index: childrenItem.path
                                    }, {
                                      title: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`sidebar.${childrenItem.meta.title}`)), 1 /* TEXT */)
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(['sidebar-icon', 'colour', { 'collapse': $setup.config.sidebarCollapse }])
                                        }, [
                                          (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                                            _createElementVNode("use", {
                                              "xlink:href": '#colour-' + childrenItem.meta.icon
                                            }, null, 8 /* PROPS */, _hoisted_8)
                                          ]))
                                        ], 2 /* CLASS */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
                      : (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: 1,
                          index: routeItem.path
                        }, {
                          title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`sidebar.${routeItem.meta.title}`)), 1 /* TEXT */)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(['sidebar-icon', 'colour', 'colour-' + routeItem.meta.icon])
                            }, null, 2 /* CLASS */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["default-active", "class", "collapse"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_drawer, {
        modelValue: $setup.config.sidebarCollapse,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.config.sidebarCollapse) = $event)),
        size: "auto",
        direction: "ltr",
        "with-header": false
      }, {
        default: _withCtx(() => [
          _createCommentVNode(" 顶部占位符 "),
          ($setup.config.android)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_el_menu, {
            router: "",
            class: "sidebar sidebar-phone",
            "default-active": $setup.menuActive
          }, {
            default: _withCtx(() => [
              _createCommentVNode("<logo/>"),
              _createVNode(_component_el_menu_item, {
                index: "/",
                class: "no-padding"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode($setup["Logo"])
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.routes, (routeItem) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: routeItem.path
                }, [
                  (routeItem.meta.sidebar && $setup.userLimit(routeItem))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (routeItem.meta.submenu)
                          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                              key: 0,
                              index: routeItem.path
                            }, {
                              title: _withCtx(() => [
                                _createCommentVNode(" <i :class=\"['sidebar-sub-icon', 'colour', 'colour-' + routeItem.meta.icon]\"></i> "),
                                _createElementVNode("i", _hoisted_12, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                                    _createElementVNode("use", {
                                      "xlink:href": '#colour-' + routeItem.meta.icon
                                    }, null, 8 /* PROPS */, _hoisted_14)
                                  ]))
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`sidebar.${routeItem.meta.title}`)), 1 /* TEXT */)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routeItem.children, (childrenItem) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: childrenItem.path
                                  }, [
                                    (childrenItem.meta.sidebar)
                                      ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                          key: 0,
                                          index: childrenItem.path
                                        }, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`sidebar.${childrenItem.meta.title}`)), 1 /* TEXT */)
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("i", {
                                              class: _normalizeClass(['sidebar-icon', 'colour', { 'collapse': $setup.config.sidebarCollapse }])
                                            }, [
                                              (_openBlock(), _createElementBlock("svg", _hoisted_15, [
                                                _createElementVNode("use", {
                                                  "xlink:href": '#colour-' + childrenItem.meta.icon
                                                }, null, 8 /* PROPS */, _hoisted_16)
                                              ]))
                                            ], 2 /* CLASS */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
                          : (_openBlock(), _createBlock(_component_el_menu_item, {
                              key: 1,
                              index: routeItem.path
                            }, {
                              title: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`sidebar.${routeItem.meta.title}`)), 1 /* TEXT */)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(['sidebar-icon', 'colour', 'colour-' + routeItem.meta.icon])
                                }, null, 2 /* CLASS */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["default-active"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}